export const SAVED_FILTERS_PREFERENCE_KEY = 'save_filters'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/** Decode the legacy preference envelope while preserving its unversioned row payload. */
export function parseSavedFiltersPreference(value: unknown): unknown[] {
  if (!isRecord(value) || value.success !== true || !isRecord(value.data)) {
    throw new TypeError('Malformed workspace preference response')
  }
  // A missing key is returned as `data: {}` and means an empty saved-filter collection.
  if (!('value' in value.data)) return []
  if (!Array.isArray(value.data.value)) {
    throw new TypeError('Malformed saved-filter preference value')
  }
  return value.data.value
}

/** The write endpoint has no domain payload; only an explicit success acknowledgement is valid. */
export function parseSavedFiltersPreferenceWrite(value: unknown): void {
  if (!isRecord(value) || value.success !== true) {
    throw new TypeError('Malformed workspace preference write response')
  }
}
